











import { computed, defineComponent, ref } from "@vue/composition-api";
import { INPUT_PROPS } from "@/const";
import BaseInput from "@/components/BaseInput";

export default defineComponent({
  name: "InputPassword",
  components: { BaseInput },
  props: { ...INPUT_PROPS },
  setup() {
    const secure = ref(true);
    const passwordIcon = computed(() => (secure.value ? "sci-eye-off-outline" : "sci-eye-outline"));

    return {
      secure,
      passwordIcon,
    };
  },
});
